/**
 * Map PDF export: print a pre-rendered SVG string of the whole map (produced
 * by `canvas/export/renderMapToSvg`) through a popup → `window.print()` →
 * vector-PDF pipeline. The canvas scene SVG is gated off the live DOM, so its
 * markup is handed in directly.
 */
export async function generateMapPdfFromSvg(
  svgMarkup: string,
  mapHeight: number,
  mapWidth: number,
  pageTitle: string,
) {
  return printMapMarkup(svgMarkup, mapHeight, mapWidth, pageTitle);
}

async function printMapMarkup(
  mapContent: string,
  mapHeight: number,
  mapWidth: number,
  pageTitle: string,
) {
  const paperSize = `${mapWidth / 96 + 5}in ${mapHeight / 96 + 1}in`; // convert to inches and add padding

  const popupWindow = window.open(
    '',
    '_blank',
    `scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no`,
  );

  if (!popupWindow) {
    console.error('popup window missing');

    return Promise.reject();
  }

  const stylesheets: string[] = [];
  document.head
    .querySelectorAll('style, link[rel="stylesheet"]')
    .forEach((htmlElement) => {
      stylesheets.push(htmlElement.outerHTML);
    });

  popupWindow.document.open();
  popupWindow.document.write(
    `<html>
      <head>
        ${stylesheets.join(' ')}
        <style>
          * {
            font-family: Roboto, sans-serif !important;
          }
          body {
            min-width: ${mapWidth}px; background-color: #fafafa;
          }
          @page { size: ${paperSize} }
          @media print { body { transform-origin: 0 0;}}
        </style>
        <title>${pageTitle}</title>
      </head>
      <body> 
        ${mapContent}
      </body>
    </html>`,
  );
  const minimap = popupWindow.document.getElementById('minimap');
  if (minimap) {
    minimap.style.display = 'none';
  }

  popupWindow.addEventListener('load', () => popupWindow.print());
  popupWindow.document.close();
  popupWindow.addEventListener('afterprint', () => popupWindow.close());

  return Promise.resolve();
}
